/* Copyright (c) 2017 Backpack Health LLC */

import { apiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';
import { PolicyInterface } from '../models/PolicyModel';

const PolicyApi = {
  getAll() {
    return apiRequest('get', 'policies');
  },
};

const PolicyService = {
  getAll(callback) {
    return PolicyApi.getAll()
      .send()
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        const policies: PolicyInterface[] = res.body.data;
        callback(apiError, policies);
      });
  },
};

export default PolicyService;
